import React, { useMemo, useRef } from "react";
import ReactQuill from "react-quill";

const ReactQuillEditor = (props) => {
  const quillRef = useRef(null);

  const handleLinkClick = () => {
    const quill = quillRef.current.getEditor();
    const range = quill.getSelection();

    if (range) {
      const defaultUrl = "{assistantUrl}";
      quill.format("link", defaultUrl); // Set the default link
    }
  };

  const quillModules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, false] }],
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link"],
          ["clean"],
        ],
        handlers: {
          link: handleLinkClick,
        },
      },
    }),
    []
  );

  return <ReactQuill ref={quillRef} modules={quillModules} {...props} />;
};

export default ReactQuillEditor;
